import React from 'react'
import PropTypes from 'prop-types'
import EmployerInformationForm from './EmployerInformationForm'
import {
  employerInformation,
} from 'utils/financialAccountDetailsConfig'
import withOnboardingSection from 'components/Onboarding/withOnboardingSection'
import {
  getJointOwner,
  getFinancialAccount,
  continueToNextSection,
  getPreviousSectionInfo,
  denormalizeEffectiveDate,
} from 'utils/financialAccounts'
import { updateFinancialAccount } from 'utils/apiRequest'
import {
  SCHWAB_IRA,
} from 'utils/financialAccountTypes.js'


const Section = withOnboardingSection(EmployerInformationForm)

const prepareFormDataForRender = (financialAccount, fields) => {
  if (!financialAccount) return

  const employerInformation = {}

  Object.keys(fields).map(key => employerInformation[key] = financialAccount.attributes[key])

  return employerInformation
}

const EmployerInformation = (props) => {
  const {
    financialAccounts,
    jointOwners,
    isMobile,
    hide,
    isLoading,
    editFinancialAccount,
    location: {
      payload: {
        financialAccountId,
        financialAccountType
      }
    },
  } = props

  const {
    upperTitle,
    description,
    fields,
    fieldsToSubmit
  } = employerInformation

  const currentSection = 'employerInformation'

  const jointOwner = getJointOwner(jointOwners, financialAccountId)

  const financialAccount = getFinancialAccount(financialAccounts, financialAccountId)

  const data = prepareFormDataForRender(financialAccount, fields)

  const handleContinueToNextSection =  () => {
    continueToNextSection({
      currentFinancialAccountId: financialAccountId,
      currentFinancialAccountType: financialAccountType,
      currentSection,
      financialAccounts,
      jointOwner,
    })
  }

  const prevPageInfo = getPreviousSectionInfo({
    financialAccounts,
    financialAccountId,
    financialAccountType,
    jointOwner,
    isMobile,
    currentSection
  })

  const buildIncomeTaxDates = (formData) => {
    const { employerIncomeTaxDate } = formData
    let taxDate = {}

    if (employerIncomeTaxDate && employerIncomeTaxDate.indexOf('/') > -1) {
      const incomeTaxDate = employerIncomeTaxDate.split('/')

      taxDate = {
        employerFiscalYearEndMonth: incomeTaxDate[0],
        employerFiscalYearEndDay: incomeTaxDate[1],
      }
    }

    return taxDate
  }

  const buildEmployerPlanEffectiveDate = (formData) => {
    const {
      employerPlanEffectiveDate,
    } = formData

    const {
      subType
    } = financialAccount.attributes

    if (!employerPlanEffectiveDate) return

    let effectiveDate = {}

    if (subType === SCHWAB_IRA.ACCOUNT_TYPES.SIMPLE_IRA) {
      if (employerPlanEffectiveDate) {
        effectiveDate = {
          employerPlanEffectiveDate: `${employerPlanEffectiveDate}-01-01`,
        }
      }
    } else {
      effectiveDate = {
        employerPlanEffectiveDate: denormalizeEffectiveDate(employerPlanEffectiveDate),
      }
    }

    return effectiveDate
  }

  const buildEmployerPriorPlanEffectiveDate = (formData) => {
    const {
      employerPriorPlanEffectiveDate
    } = formData

    if (!employerPriorPlanEffectiveDate) return

    return {
      employerPriorPlanEffectiveDate: denormalizeEffectiveDate(employerPriorPlanEffectiveDate),
    }
  }

  const submitAction = (formData) => {
    const submitData = {
      ...formData,
      ...buildIncomeTaxDates(formData),
      ...buildEmployerPlanEffectiveDate(formData),
      ...buildEmployerPriorPlanEffectiveDate(formData),
      reviewedEmployerDetails: true,
    }

    if (!submitData.employerPlanEffectiveDate) {
      delete submitData.employerPlanEffectiveDate
    }

    if (!submitData.employerPriorPlanEffectiveDate) {
      delete submitData.employerPriorPlanEffectiveDate
    }

    return updateFinancialAccount(financialAccountId, submitData)
  }

  const getSubType = () => {
    if (financialAccount) {
      const {
        attributes: {
          subType
        }
      } = financialAccount

      return subType
    }

    return ''
  }

  const finalDescription = [description[0].replace('{subType}', getSubType())]

  return (
    <Section
      {...props}
      formName={upperTitle}
      description={finalDescription}
      data={data}
      prevPageInfo={prevPageInfo}
      goNextSection={handleContinueToNextSection}
      isLoading={isLoading}
      isMobile={isMobile}
      hide={hide || isLoading}
      setData={editFinancialAccount}
      submitAction={submitAction}
      mapValues={fieldsToSubmit}
      subType={getSubType()} />
  )
}

EmployerInformation.propTypes = {
  hide: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  financialAccounts: PropTypes.arrayOf(PropTypes.object).isRequired,
  jointOwners: PropTypes.arrayOf(PropTypes.object).isRequired,
  editFinancialAccount: PropTypes.func.isRequired,
  attributes: PropTypes.object.isRequired
}

export default EmployerInformation



// WEBPACK FOOTER //
// ./src/components/Onboarding/EmployerInformation/EmployerInformation.js